import { Grid, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import AcxButton from "components/UI/AcxButton";
import ClassifierBuilderTips from "../ClassifierBuilderTips";
import StandardClassifierBuilderStore from "./StandardClassifierBuilderStore";
import StandardClassifierBuilderGroup from "./StandardClassifierBuilderGroup";

interface Props {
    store: StandardClassifierBuilderStore;
}

const StandardClassifierBuilder: React.FunctionComponent<Props> = observer(
    ({ store }) => {
        const theme = useTheme();
        return (
            <>
                <Grid container item xs={12}>
                    {!!store.classifierGroups.length ? (
                        store.classifierGroups.map((group, index) => (
                            <StandardClassifierBuilderGroup
                                group={group}
                                groupIndex={index}
                                store={store}
                                key={"group-" + index}
                            />
                        ))
                    ) : (
                        <ClassifierBuilderTips />
                    )}
                </Grid>
                <AcxButton
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        store.addClassifierBuilderGroup(0);
                    }}
                    sx={{
                        color: theme.palette.primary.main,
                        "&:hover": {
                            color: "white",
                        },
                    }}
                >
                    <AddIcon /> New Group
                </AcxButton>
            </>
        );
    },
);

export default StandardClassifierBuilder;
